<template>
<!-- Iframes: Standard -->
<div class="etx-container Container" :class="paragraphClassList">
  <div class="etx-center Center">
		
    <div class="Iframe" :class="entranceClassList" v-html="code" />
		
  </div>
</div>
</template>

<script lang="ts" setup>

defineProps<{
  code: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'iframe_standard',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

</script>
